import { jsonSchema } from "@redotech/redo-automations-model/graph/automation";
import * as z from "zod";
import { definitionInputSchema, diagnosticSchema } from "./common";

/** Every path through a definition ("All paths"), each with a scenario that drives it when one was found. */
export const explore = {
  name: "explore" as const,
  input: z.object({ definition: definitionInputSchema }),
  output: z.discriminatedUnion("ok", [
    z.object({
      ok: z.literal(true),
      paths: z.array(
        z.object({
          id: z.string(),
          steps: z.array(
            z.object({
              nodeId: z.string(),
              port: z.string(),
              label: z.string(),
              how: z.enum([
                "linear",
                "branch",
                "outcome",
                "disabled",
                "admission",
              ]),
            }),
          ),
          end: z.enum([
            "completed",
            "failed",
            "rejected:filtered",
            "rejected:entry-conditions",
            "rejected:frequency-cap",
          ]),
          /** proven: a witness drives it; infeasible: no input can. */
          status: z.enum(["proven", "infeasible", "unknown"]),
          /** A scenario that takes this path; pass it to `simulate`. */
          witness: jsonSchema.nullable(),
          note: z.string().nullable(),
        }),
      ),
      truncated: z.boolean(),
      /** Nodes no feasible path reaches; empty when exploration was truncated. */
      unreachable: z.array(z.string()),
    }),
    z.object({ ok: z.literal(false), diagnostics: z.array(diagnosticSchema) }),
  ]),
};
